/**
 * How much of the map's right edge is covered by a panel right now.
 *
 * The map canvas is the full window width with the sidebar painted on top, so
 * anything floating over the map has to know where the usable area really ends.
 * Measuring beats inferring from a prop: the panels slide in and out on a CSS
 * transform (which no observer reports), there are two of them at different
 * widths, and either can be open on any screen size. A hidden panel is
 * translated fully off-screen, so its measured overlap is naturally zero.
 */
import { useEffect, useState } from 'react';

const RIGHT_PANELS = ['#sidebar', '#sidebar40e'];

export function useRightInset() {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    let current = -1;
    const measure = () => {
      let max = 0;
      for (const sel of RIGHT_PANELS) {
        const el = document.querySelector(sel);
        if (!el) continue;
        const r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) continue;
        const overlap = window.innerWidth - r.left;
        // A panel covering most of the screen (a full-width mobile sheet) would
        // squeeze the content to nothing; the map isn't visible then anyway.
        if (overlap > 0 && overlap < window.innerWidth * 0.6) max = Math.max(max, overlap);
      }
      if (max !== current) { current = max; setInset(max); }
    };
    measure();
    window.addEventListener('resize', measure);
    document.addEventListener('transitionend', measure, true);
    const poll = setInterval(measure, 600);
    return () => {
      window.removeEventListener('resize', measure);
      document.removeEventListener('transitionend', measure, true);
      clearInterval(poll);
    };
  }, []);

  return inset;
}
